// Icons actively imported by components — unused exports removed
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import SavingsIcon from "@mui/icons-material/Savings";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AirIcon from "@mui/icons-material/Air";
import KitchenIcon from "@mui/icons-material/Kitchen";
import ShowerIcon from "@mui/icons-material/Shower";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const Add = AddIcon;
export const Remove = RemoveIcon;
export const ArrowForward = ArrowForwardIcon;
export const ArrowBack = ArrowBackIcon;
export const BoltRounded = BoltRoundedIcon;
export const Savings = SavingsIcon;
export const LocationOn = LocationOnIcon;
export const Air = AirIcon;
export const Kitchen = KitchenIcon;
export const Shower = ShowerIcon;
export const PictureAsPdf = PictureAsPdfIcon;
export const TrendingUp = TrendingUpIcon;
export const CheckCircleOutline = CheckCircleOutlineIcon;
export const EmojiEvents = EmojiEventsIcon;
export const InfoOutlined = InfoOutlinedIcon;
